var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83145 2.4375C3.05113 2.4375 2.41812 3.05124 2.41812 3.80735V20.1913C2.41812 20.9475 3.0512 21.5607 3.83145 21.5607H20.128C20.9086 21.5607 21.5413 20.9474 21.5413 20.1911V3.80735C21.5413 3.05124 20.9086 2.4375 20.128 2.4375H3.83145ZM8.22965 9.82983V18.4391H5.36804V9.82983H8.22965ZM8.41827 7.16732C8.41827 7.9935 7.79714 8.65459 6.79945 8.65459L6.79922 8.65451H6.7807C5.82028 8.65451 5.19937 7.99342 5.19937 7.16725C5.19937 6.32233 5.83903 5.67969 6.81842 5.67969C7.79714 5.67969 8.39959 6.32233 8.41827 7.16732ZM12.675 18.4391H9.81359L9.81352 18.4394C9.81352 18.4394 9.85109 10.6378 9.81374 9.83013H12.6752V11.0487C13.0556 10.4622 13.7364 9.62799 15.2542 9.62799C17.1369 9.62799 18.5484 10.8585 18.5484 13.5028V18.4391H15.6871V13.8339C15.6871 12.6764 15.2727 11.887 14.2375 11.887C13.4468 11.887 12.976 12.4194 12.7692 12.9337C12.6936 13.1172 12.675 13.3748 12.675 13.6318V18.4391Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.d92d18f84d955d906f50939989e6a7f6.svg";
export { ForwardRef as ReactComponent };